/* HB ROUND 3 — assets/hb-round3.js (19 Oct 2026)
   1. Add-to-cart feedback: button flashes "✓ Added", cart icon bumps, screen readers hear it.
   2. Phone zoom: tap a product image for a full-screen, high-res view (double-tap = 2x, pinch works).
   3. Foil sheen + tilt on foil cards and the hero fan (pointer devices, motion allowed only).
   4. Page transitions: the clicked card glides into the product page (View Transitions API).
   No third-party code. Everything degrades to the normal theme behaviour. */
(function () {
  'use strict';
  if (window.__hbRound3) return;
  window.__hbRound3 = 1;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- live region ---------- */
  var live = document.createElement('div');
  live.className = 'hb-sr'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite');
  function say(t) { live.textContent = ''; setTimeout(function () { live.textContent = t; }, 30); }

  /* ---------- 1. add-to-cart feedback ---------- */
  var lastBtn = null;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && /\/cart\/add/.test(f.action)) lastBtn = f.querySelector('[type=submit], button[name=add]');
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name=add], .quick-add__submit, button[type=submit]');
    if (b && b.form && /\/cart\/add/.test(b.form.action || '')) lastBtn = b;
  }, true);

  function celebrate() {
    var b = lastBtn; lastBtn = null;
    if (b && !reduce) {
      b.classList.add('hb-added');
      setTimeout(function () { b.classList.remove('hb-added'); }, 1600);
    }
    var bub = document.getElementById('cart-icon-bubble');
    if (bub && !reduce) { bub.classList.remove('hb-bump'); void bub.offsetWidth; bub.classList.add('hb-bump'); }
    say('Added to your cart.');
  }
  /* Watch the cart endpoint itself, whoever calls it (product form, quick add, our tools). */
  var of = window.fetch;
  if (of && !of.__hbR3) {
    var w = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add/.test(url)) p.then(function (r) { if (r && r.ok) celebrate(); }).catch(function () {});
      return p;
    };
    w.__hbR3 = 1; window.fetch = w;
  }

  /* ---------- 2. phone zoom ---------- */
  var mqPhone = window.matchMedia && matchMedia('(max-width: 749px)');
  var dlg = null, dImg = null;
  function bigSrc(img) {
    var s = img.currentSrc || img.src || '';
    if (!s) return '';
    return s.replace(/([?&])width=\d+/, '$1width=1600').replace(/(_\d+x\d*)?(\.(jpg|jpeg|png|webp))/i, '$2');
  }
  function openZoom(img) {
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'hb-zoom';
      dlg.setAttribute('aria-label', 'Card image, zoomed');
      dlg.innerHTML = '<button class="hb-zoom__x" type="button" aria-label="Close zoom">×</button>' +
        '<div class="hb-zoom__stage"><img class="hb-zoom__img" alt=""></div>' +
        '<p class="hb-zoom__tip">Double-tap for 2×. Pinch to zoom further.</p>';
      document.body.appendChild(dlg);
      dImg = dlg.querySelector('.hb-zoom__img');
      dlg.querySelector('.hb-zoom__x').addEventListener('click', function () { dlg.close(); });
      var lastTap = 0;
      dlg.querySelector('.hb-zoom__stage').addEventListener('click', function (e) {
        var now = Date.now();
        if (now - lastTap < 320) {
          var on = !dlg.classList.contains('is-2x');
          dlg.classList.toggle('is-2x', on);
          if (on) {
            var st = dlg.querySelector('.hb-zoom__stage'), r = st.getBoundingClientRect();
            requestAnimationFrame(function () {
              st.scrollLeft = (e.clientX - r.left) * 2 - r.width / 2;
              st.scrollTop = (e.clientY - r.top) * 2 - r.height / 2;
            });
          }
          lastTap = 0;
        } else lastTap = now;
      });
      dlg.addEventListener('close', function () { dlg.classList.remove('is-2x'); });
    }
    dImg.src = bigSrc(img);
    dImg.alt = img.alt || 'Card image';
    if (typeof dlg.showModal === 'function') dlg.showModal(); else window.open(dImg.src, '_blank', 'noopener');
  }
  function wireZoom() {
    var list = document.querySelector('.product__media-list');
    if (!list) return;
    var gallery = list.closest('media-gallery') || list.parentElement;
    if (gallery && !gallery.querySelector('.hb-zoom-hint')) {
      var hint = document.createElement('p');
      hint.className = 'hb-zoom-hint'; hint.textContent = 'Tap the card to zoom';
      gallery.appendChild(hint);
    }
    list.addEventListener('click', function (e) {
      if (!mqPhone || !mqPhone.matches) return;
      var item = e.target.closest('.product__media-item');
      var img = item && item.querySelector('.product__media img, img');
      if (!img) return;
      e.preventDefault(); e.stopPropagation();
      openZoom(img);
    }, true);
  }

  /* ---------- 3. foil sheen + tilt ---------- */
  function makeFoil(el, badge, host) {
    host = host || el;
    if (!el || el.__hbFoil) return;
    el.__hbFoil = 1;
    el.classList.add('hb-foil');
    var s = document.createElement('span'); s.className = 'hb-sheen'; s.setAttribute('aria-hidden', 'true');
    el.appendChild(s);
    if (badge) { var b = document.createElement('span'); b.className = 'hb-foil-badge'; b.textContent = 'FOIL'; b.setAttribute('aria-hidden', 'true'); el.appendChild(b); }
    if (reduce || !finePointer) return;
    var raf = 0, px = 0.5, py = 0.5, tilt = !el.classList.contains('hbh__card');
    function paint() {
      raf = 0;
      el.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
      el.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      el.style.setProperty('--bx', (20 + px * 60).toFixed(1) + '%');
      el.style.setProperty('--by', (20 + py * 60).toFixed(1) + '%');
      if (tilt) el.style.transform = 'perspective(700px) rotateY(' + ((px - 0.5) * 12).toFixed(2) + 'deg) rotateX(' + ((0.5 - py) * 12).toFixed(2) + 'deg)';
    }
    host.addEventListener('pointerenter', function () { el.classList.add('is-live'); });
    host.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      px = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      py = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
      if (!raf) raf = requestAnimationFrame(paint);
    });
    host.addEventListener('pointerleave', function () {
      el.classList.remove('is-live');
      if (raf) cancelAnimationFrame(raf), raf = 0;
      if (tilt) el.style.transform = '';
    });
  }
  function scanFoils(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(function (w) {
      if (!w.querySelector('.hbc-foil')) return;
      var media = w.querySelector('.card__inner') || w.querySelector('.card__media');
      if (media) makeFoil(media, false, w);
    });
    document.querySelectorAll('.hbh__card').forEach(function (c) { makeFoil(c, false); });
    // product page: selected variant is a foil
    var pick = document.querySelector('variant-selects input:checked, variant-selects option:checked, variant-selects select option:checked');
    var title = (document.querySelector('.product__title') || {}).textContent || '';
    var isFoil = /foil/i.test(title) || (pick && /foil/i.test(pick.value || ''));
    var main = document.querySelector('.product__media-list .product__media-item:first-child .product__media');
    if (main && isFoil) makeFoil(main, true);
  }

  /* ---------- 4. page transitions: name the clicked card's image ---------- */
  document.addEventListener('click', function (e) {
    if (reduce || !('startViewTransition' in document)) return;
    var a = e.target.closest && e.target.closest('.card-wrapper a[href*="/products/"], a.hbh__card');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var wrap = a.closest('.card-wrapper') || a;
    var img = wrap.querySelector('.card__media img, img');
    document.querySelectorAll('[style*="view-transition-name"]').forEach(function (n) { n.style.viewTransitionName = ''; });
    document.querySelectorAll('.product__media-list img').forEach(function (n) { n.style.viewTransitionName = 'none'; });
    if (img) img.style.viewTransitionName = 'hb-card';
  }, true);

  function start() {
    document.body.appendChild(live);
    wireZoom();
    scanFoils();
    var grid = document.getElementById('product-grid');
    if (grid && 'MutationObserver' in window) new MutationObserver(function () { scanFoils(grid); }).observe(grid, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
